import { useContext } from 'react'
import { ComponentVersionsContext, ComponentVersionsKey } from '../context/ComponentVersionsContext'

export const useComponentVersion = (componentName: ComponentVersionsKey) => {
  const context = useContext(ComponentVersionsContext)
  return context[componentName]
}
